import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'

export default (props) => {
  return (
      <Button size='middle' onClick={props.onCancelClick || props.history?.goBack} block={props.block}>
        <ArrowLeftOutlined />
        <span style={{ fontSize: 14 }}>Back</span>
      </Button>
  )
}
